import {
  BOOKS_BOOK_DETAIL_SET_DATA,
  BOOKS_BOOK_DETAIL_RESET_DATA,
} from 'rebook/apps/books/constants';


const initialState = {
  book: null,
  seriesList: null,
  reviews: null,
  citations: null,
  booksets: null,
  authorBooks: null,
  authorAudioBooks: null,
  similarBooks: null,
  connectedBook: null,
  showPlayer: false,
};

export default function bookDetail(state = initialState, action) {
  switch (action.type) {
    case BOOKS_BOOK_DETAIL_SET_DATA:
      return {
        ...state,
        ...action.payload,
      };
    case BOOKS_BOOK_DETAIL_RESET_DATA:
      return initialState;
    default:
      return state;
  }
}
